module.exports = __webpack_public_path__ + "static/assets/dda5e8c95b651c2de8a8e98fa02359df.png";